import React from "react";
import styles from "./comparison-section-mobile.module.scss";
import { useTranslation } from "react-i18next";
import minusIcon from "@/assets/minus.svg";
import plusIcon from "@/assets/plus.svg";
import {Icon} from "@/elements-react/fix-icon";

export const ComparisonSectionMobile: React.FC = () => {
    const { t } = useTranslation();

    const comparisonRows = [
        { traditional: "Emails and phone calls", b2b: "One unified platform" },
        { traditional: "Manual price checks", b2b: "Instant pricing" },
        { traditional: "Limited visibility", b2b: "Full order control" },
        { traditional: "Slow decisions", b2b: "Faster purchasing" }
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>
                {t("A more efficient way to manage auto parts ordering")}
            </h2>
            <p className={styles.subtitle}>
                {t("Expertise you can rely on")}
            </p>

            <div className={styles.tableContainer}>
                <div className={styles.headers}>
                    <div className={styles.columnTitle}>{t("Traditional ordering")}</div>
                    <div className={styles.columnTitle}>{t("Our B2B system")}</div>
                </div>
                <div className={styles.rows}>
                    {comparisonRows.map((row, index) => (
                        <div key={index} className={styles.row}>
                            <div className={styles.item}>
                                <div className={styles.iconContainer}>
                                    <Icon src={minusIcon} className={styles.minusIcon} />
                                </div>
                                <span>{t(row.traditional)}</span>
                            </div>
                            <div className={styles.item}>
                                <div className={styles.iconContainer}>
                                    <Icon src={plusIcon} className={styles.plusIcon} />
                                </div>
                                <span>{t(row.b2b)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
